import { useState } from "react";

import VulnerabilityContext, { Answers, PrivacyNoticeAnswer } from "./VulnerabilityContext";

const VulnerabilityContextProvider: React.FC<{children: React.ReactNode}> = (props) => {
  const [answers, setAnswers] = useState<Answers>({});
  const [submitted, setSubmitted] = useState(false);

  const [privacyNoticeAnswer, setPrivacyNoticeAnswer] = useState<PrivacyNoticeAnswer>(PrivacyNoticeAnswer.None);

  return (
    <VulnerabilityContext.Provider value={{ 
      answers, 
      setAnswers, 
      privacyNoticeAnswer, 
      setPrivacyNoticeAnswer,
      submitted, 
      setSubmitted,
    }}>
      {props.children}
    </VulnerabilityContext.Provider>
  );
};

export default VulnerabilityContextProvider;
